import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

export const AssistantBodyBubble = ({ children }: { children: ReactNode }) => (
  <div className="flex w-full flex-col">
    <div className="flex flex-col gap-3">
      <Typography
        variant="body-sm"
        color="primary"
        component="div"
        className="break-words"
      >
        {children}
      </Typography>
    </div>
  </div>
);
